<template>
  <v-card v-if="form">
    <v-card-title class="pb-0 pb-4">
      <v-icon class="mr-3" style="background:#e7e8e9; padding:10px; border-radius:50%;">mdi-file-edit</v-icon>
      <span>Editar Archivo #{{ form.id }}</span>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-divider />

    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" md="6" class="pb-0">
            <v-text-field :value="form.influencer_label" label="Influencer" disabled />
          </v-col>

          <v-col cols="12" md="6" class="pb-0">
            <v-text-field :rules="[rules.required]" v-model="form.title" label="Título" />
          </v-col>

          

          <v-col cols="12" md="12">
            <!-- Archivo actual -->
            <div class="mb-2" v-if="form.url">
              Archivo actual:
              <a :href="fileHref(form.url)" target="_blank">{{ form.url }}</a>
            </div>
            <!-- Reemplazar archivo -->
            <v-file-input
              label="Reemplazar archivo"
              accept="*/*"
              prepend-icon="mdi-paperclip"
              :loading="uploading"
              show-size
              counter
              @change="onFileSelected"
            />
          </v-col>
          
          <v-col cols="12">
            <v-textarea v-model="form.description" label="Descripción" auto-grow />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text color="grey" @click="$emit('close')">Cancelar</v-btn>
      <v-btn color="primary" :disabled="!isValid" :loading="saving" @click="save">Guardar</v-btn>
    </v-card-actions>

    <v-snackbar :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.message }}
    </v-snackbar>
  </v-card>
</template>

<script>
import axios from 'axios'

export default {
  name: 'InfluencerFilesEdit',
  props: { item: { type: Object, required: true } },
  data: () => ({
    form: null,
    additionalDataText: '',
    uploading: false,
    saving: false,
    snackbar: { show: false, message: null, color: null },
    rules: { required: v => !!v || 'Campo requerido' },
  }),
  computed: {
    isValid () {
      return this.form && !!this.form.title && !!this.form.url && !this.saving && !this.uploading
    },
    filesBase () {
      return process.env.VUE_APP_FILES_ROUTE || 'https://peach.blitzhub.mx/files/'
    }
  },
  watch: {
    item: {
      immediate: true,
      handler (val) {
        if (!val) return
        const inf = val.influencer
        const label =
          inf && inf.social_networks && inf.social_networks.instagram
            ? inf.social_networks.instagram
            : (inf && inf.name ? inf.name : ('#' + (val.influencer_id || '')))
        this.form = {
          id: val.id,
          influencer_id: val.influencer_id,
          influencer_label: label,
          title: val.title || '',
          description: val.description || '',
          url: val.url || '',          // nombre del archivo guardado en DB
          type: val.type || '',
          additional_data: val.additional_data || null
        }
        try {
          this.additionalDataText = val.additional_data ? (
            typeof val.additional_data === 'string' ? val.additional_data : JSON.stringify(val.additional_data, null, 2)
          ) : ''
        } catch (e) {
          this.additionalDataText = ''
        }
      }
    }
  },
  methods: {
    fileHref (nameOrUrl) {
      if (!nameOrUrl) return ''
      return /^https?:\/\//i.test(nameOrUrl) ? nameOrUrl : (this.filesBase + nameOrUrl)
    },
    async onFileSelected (fileOrArray) {
      const file = Array.isArray(fileOrArray) ? fileOrArray[0] : fileOrArray
      if (!file) return
      const formData = new FormData()
      formData.append('file', file)

      this.uploading = true
      try {
        // mismo endpoint de ejemplo para obtener nombre
        const res = await axios({
          url: process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/sale/file',
          method: 'POST',
          data: formData,
        })
        const name = (res && res.data && (res.data.file || res.data.filename || res.data.name)) ? (res.data.file || res.data.filename || res.data.name) : ''
        if (!name) throw new Error('Respuesta sin nombre de archivo')
        this.form.url = name
        this.snackbar = { show: true, color: 'success', message: 'Archivo subido' }
      } catch (err) {
        this.snackbar = { show: true, color: 'error', message: 'Error al subir archivo' }
      } finally {
        this.uploading = false
      }
    },
    parseAdditionalData () {
      if (!this.additionalDataText) return null
      try { return JSON.parse(this.additionalDataText) }
      catch (e) {
        this.snackbar = { show: true, color: 'error', message: 'JSON inválido en Datos adicionales' }
        return '__INVALID__'
      }
    },
    async save () {
      const ad = this.parseAdditionalData()
      if (ad === '__INVALID__') return

      const payload = {
        title: this.form.title,
        description: this.form.description,
        url: this.form.url,               // nombre del archivo (no la URL completa)
        influencer_id: this.form.influencer_id,
        type: this.form.type || '',
        additional_data: ad
      }

      this.saving = true
      try {
        await axios.patch(process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/influencer_files/' + this.form.id, payload)
        this.$emit('saved')
        this.snackbar = { show: true, color: 'success', message: 'Actualizado correctamente' }
      } catch (e) {
        this.snackbar = { show: true, color: 'error', message: 'No se pudo actualizar' }
      } finally {
        this.saving = false
      }
    },
  }
}
</script>
